import React from 'react';
import Table from 'react-bootstrap/Table';
import { consultantDisplayName, dateDiffFormatter, getSortIcon, invoiceAmountFormatter, niceDateFormatter } from '../../lib/helper/formatting';
import Modal from 'react-modal';
import { invoiceDelete, invoiceSingleFetch, invoiceSingleUnload } from '../../lib/redux/actions/invoices';
import { connect } from 'react-redux';
import Form from 'react-bootstrap/Form';
import { renderCheckbox } from '../../lib/helper/form';
import clsx from 'clsx';
import * as ROUTES from '../../lib/routing/frontend';
import { Link } from 'react-router-dom';

import { isChaserOutsourcer } from '../../lib/helper/authorisation';
import Badge from 'react-bootstrap/Badge';

Modal.setAppElement('#root');

const mapStateToProps = (state) => ({
  ...state.invoices,
  ...state.invoice,
});

const mapDispatchToProps = {
  invoiceSingleFetch,
  invoiceSingleUnload,
  invoiceDelete,
};

// PropTypes for changedInvoices:
// changedInvoices: {
//   new: { [invoiceId]: true },
//   updated: { [invoiceId]: true },
//   timestamp: Date
// }

const getInvoiceStatus = function (invoice) {
  if (invoice?.isVoid) {
    return 'Void';
  } else if (invoice?.isPaid) {
    return 'Paid';
  } else if (invoice?.isWrittenOff) {
    return 'WriteOff';
  } else {
    return 'Unpaid';
  }
};

class InvoiceListTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      modalIsOpen: false,
      invoiceIDInModal: false,
    };
  }

  openModal = (invoiceID) => {
    this.setState({ modalIsOpen: true, invoiceIDInModal: invoiceID });
  };

  closeModal = () => {
    this.setState({ modalIsOpen: false, invoiceIDInModal: false });
    this.props.invoiceSingleUnload();
    // Do we need to do some sort of unloading?
  };

  afterModalOpen = () => {
    this.props.invoiceSingleFetch(this.state.invoiceIDInModal);
  };

  render() {
    const {
      pageType,
      invoices,
      showBulkSelect = false,
      bulkSelectAction = () => {},
      bulkSelectedInvoices = [],
      changedInvoices = { new: {}, updated: {} },
      columnOverrides = [],
    } = this.props;

    if (!invoices || invoices.length === 0) {
      return null;
    }
    return (
      <div style={{ overflow: 'none' }}>
        {/*<pre>{JSON.stringify(invoices[0], null, 2)}</pre>*/}
        <Table striped hover responsive className="mb-0">
          <thead>
            <tr>
              {showBulkSelect && <th>Select</th>}
              {/*<th>Item ID</th>*/}
              <th>Inv. No</th>
              <th>Batch</th>
              <th>Consultant</th>
              {!columnOverrides.some((col) => col === 'hospital' || (typeof col === 'object' && col.hospital === false)) && <th>Hospital / (T. Setting)</th>}
              <th>Patient Name</th>
              <th>Service Date</th>
              {!columnOverrides.some((col) => col === 'invoiceDate' || (typeof col === 'object' && col.invoiceDate === false)) && (
                <th
                  className={'pointer'}
                  onClick={() => {
                    return this.props.orderByInvoiceDate();
                  }}>
                  Inv. Date / (Days O/S) {getSortIcon(this.props.invoiceDateOrderBy)}
                </th>
              )}
              <th>O/S / Amount</th>
              <th>Payor Type</th>
              <th>Assigned To</th>
              {pageType === 'escalation' ? <th>Last Chased</th> : null}

              {!columnOverrides.some((col) => col === 'lastContact' || (typeof col === 'object' && col.lastContact === false)) && <th>Last Contact</th>}
              {pageType === 'escalation' ? <th>Escalation Reason</th> : null}
              {pageType === 'escalation' ? <th>Escalation Status</th> : <th>Status</th>}
              {pageType === 'escalation' || isChaserOutsourcer() ? (
                <th
                  className={'pointer'}
                  onClick={() => {
                    return this.props.orderByRevisitDay();
                  }}>
                  Revisit Date {getSortIcon(this.props.revisitOrderBy)}
                </th>
              ) : null}
              {pageType === 'missing' ? <th className={'text-center'}>Consultant Contacted</th> : null}
              {pageType === 'missing' ? <th className={'text-center'}>Missing Data</th> : null}
              {/*{isSeniorStaff() ? <th className={'text-center'}>Auto Chase</th> : null}*/}
              {!columnOverrides.some((col) => col === 'actions' || (typeof col === 'object' && col.actions === false)) && (
                <th className="text-right">Action</th>
              )}
            </tr>
          </thead>
          <tbody>
            {invoices.map((tableInvoice) => {
              const isBulkSelected = showBulkSelect && bulkSelectedInvoices.some((invoiceId) => invoiceId === tableInvoice.id);

              const isProblem = tableInvoice.isEscalated || tableInvoice.isMissingContactDetails;

              // Check if this invoice is new or updated
              const isNewInvoice = false; // changedInvoices?.new && changedInvoices.new[tableInvoice.id]; removed to stop table colour party
              const isUpdatedInvoice = changedInvoices?.updated && changedInvoices.updated[tableInvoice.id];

              const rowClasses = clsx({
                'table-row--paid': tableInvoice.isPaid && !tableInvoice.isVoid,
                'table-row--problem': isProblem,
                'table-row--selected': isBulkSelected,
                'table-row--writeoff': tableInvoice.isWrittenOff,
                'table-row--void': tableInvoice.isVoid,
                'table-row--new': isNewInvoice,
                'table-row--updated': isUpdatedInvoice && !isNewInvoice,
              });

              return (
                <tr key={tableInvoice.id} className={rowClasses}>
                  {showBulkSelect && (
                    <td>
                      <Form.Check
                        type={'switch'}
                        name={`invoices.${tableInvoice.id}`}
                        id={`invoices.${tableInvoice.id}`}
                        onChange={() => bulkSelectAction(tableInvoice)}
                        component={renderCheckbox}
                        className="mb-4"
                        checked={isBulkSelected}
                      />
                    </td>
                  )}

                  <td>
                    <Link to={ROUTES.INVOICES.SINGLE.replace(':id', tableInvoice.id)} className="btn btn-sm btn-outline-dark">
                      {tableInvoice.invoiceNo}
                    </Link>

                    {tableInvoice.isEscalated && <i className="ml-2 fas fa-exclamation-circle text-danger" title="Escalated" />}
                    {tableInvoice.disableChasing && <i className="ml-2 fas fa-pause-circle text-danger" title="Notifications Paused" />}

                    {tableInvoice.isMissingContactDetails && tableInvoice?.missingContactDetailsType && (
                      <>
                        {tableInvoice.missingContactDetailsType.code === '0' && (
                          <i className="ml-2 fas fa-phone text-danger" title={tableInvoice.missingContactDetailsType.name} />
                        )}
                        {tableInvoice.missingContactDetailsType.code === '10' && (
                          <i className="ml-2 fas fa-envelope text-danger" title={tableInvoice.missingContactDetailsType.name} />
                        )}
                        {tableInvoice.missingContactDetailsType.code === '20' && (
                          <>
                            <i className="ml-2 fas fa-phone text-danger" title={tableInvoice.missingContactDetailsType.name} />
                            <i className="ml-2 fas fa-envelope text-danger" title={tableInvoice.missingContactDetailsType.name} />
                          </>
                        )}
                      </>
                    )}
                  </td>
                  <td>
                    {tableInvoice.invoiceBatch ? (
                      <Link
                        to={ROUTES.INVOICE_BATCHES.SINGLE.replace(':id', tableInvoice.invoiceBatch.id)}
                        className="btn btn-sm btn-outline-secondary"
                        target="_blank"
                        rel="noopener noreferrer">
                        Batch {tableInvoice.invoiceBatch.id}
                      </Link>
                    ) : (
                      '-'
                    )}
                  </td>
                  <td>{tableInvoice.consultant ? <strong>{consultantDisplayName(tableInvoice.consultant)}</strong> : ''}</td>
                  {!columnOverrides.some((col) => col === 'hospital' || (typeof col === 'object' && col.hospital === false)) && (
                    <td>{tableInvoice.hospital ? <strong>{tableInvoice.hospital.name}</strong> : ''}</td>
                  )}
                  <td>
                    <strong>{tableInvoice.patientLastName + ', ' + tableInvoice.patientFirstName}</strong>
                    <br />
                    DOB: {tableInvoice.dateOfBirth ? niceDateFormatter(tableInvoice.dateOfBirth, 'DD/MM/YYYY') : ''}
                  </td>
                  <td>{tableInvoice.serviceDate ? niceDateFormatter(tableInvoice.serviceDate, 'DD/MM/YYYY') : ''}</td>
                  {!columnOverrides.some((col) => col === 'invoiceDate' || (typeof col === 'object' && col.invoiceDate === false)) && (
                    <td>
                      {tableInvoice.invoiceDate ? niceDateFormatter(tableInvoice.invoiceDate, 'DD/MM/YYYY') : ''}
                      {tableInvoice.invoiceDate ? ' / (' + dateDiffFormatter(false, tableInvoice.invoiceDate) + ')' : ''}
                    </td>
                  )}
                  <td>
                    <strong>{invoiceAmountFormatter(tableInvoice.outstandingBalance)}</strong> / {invoiceAmountFormatter(tableInvoice.invoiceAmount)}
                    {tableInvoice.outstandingBalance < tableInvoice.invoiceAmount && (
                      <>
                        <br />
                        <Badge variant={'danger'}>Part Paid</Badge>
                      </>
                    )}
                  </td>
                  <td>{tableInvoice?.payorType?.name ?? 'unknown'}</td>
                  <td>{tableInvoice.assignedTo ? <strong>{tableInvoice.assignedTo.firstName + ' ' + tableInvoice.assignedTo.lastName}</strong> : ''}</td>
                  {pageType === 'escalation' ? (
                    <td>{tableInvoice.lastChasedAtDate ? niceDateFormatter(tableInvoice.lastChasedAtDate, 'DD/MM/YYYY') : ''}</td>
                  ) : null}
                  {!columnOverrides.some((col) => col === 'lastContact' || (typeof col === 'object' && col.lastContact === false)) && (
                    <td>{tableInvoice.dateOfLastContact ? niceDateFormatter(tableInvoice.dateOfLastContact, 'DD/MM/YYYY') : ''}</td>
                  )}
                  {pageType === 'escalation' ? <td>{tableInvoice.invoiceEscalationReason?.reason}</td> : null}
                  <td>{pageType === 'escalation' ? tableInvoice.invoiceEscalationStatus?.status : getInvoiceStatus(tableInvoice)}</td>
                  {pageType === 'escalation' || isChaserOutsourcer() ? (
                    <td>{tableInvoice.revisitDate ? niceDateFormatter(tableInvoice.revisitDate) : null}</td>
                  ) : null}

                  {pageType === 'missing' ? <td className={'text-center'}>{tableInvoice?.consultantContactedForMissingDetails ? 'Yes' : 'No'}</td> : null}
                  {pageType === 'missing' ? (
                    <td className={'text-center'}>{tableInvoice?.missingContactDetailsType ? tableInvoice?.missingContactDetailsType.name : null}</td>
                  ) : null}

                  {!columnOverrides.some((col) => col === 'actions' || (typeof col === 'object' && col.actions === false)) && (
                    <td className="text-sm-left text-md-right">
                      <Link to={ROUTES.INVOICES.SINGLE.replace(':id', tableInvoice.id)} className="btn btn-sm btn-primary ml-2">
                        Process
                      </Link>
                    </td>
                  )}
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceListTable);
